import { EditOutlined} from "@ant-design/icons";
import { Space, Table, Drawer , Button } from 'antd';
import React from 'react';
import { useState } from 'react';
import { useEffect } from 'react';
import { useDispatch,useSelector } from 'react-redux';

import occupationService from "../../../api/occupation.service";





import { ADD_MODE, DEFAULT_MASTER_DRAWER_WIDTH, EDIT_MODE } from '../../../utility/Constants';
import DrawableCloseIcon from "../../common/DrawableCloseIcon";
import OccupationEntry from "./OccupationEntry";
import CustomTableSearch from "../../common/CustomTableSearch";




const OccupationList = () => {
    const state = useSelector((state)=>state.occupation)
    
    const showTotal = (total, range) => `${range[0]}-${range[1]} of ${total} items`;
    const [page, setPage] = React.useState(1);

    const [visible, setVisible] = useState(false);
    const [filteredSearchList, setFilteredSearchList] = useState([]);
    const [occupationList, setOccupationList] = useState([]);
    const [occupationData, setOccupationData] = useState({
        id: 0,
        occupation_name: '',
        mode: EDIT_MODE
    });
  
    const showDrawer = (rowdata) => {
    
      setOccupationData({
        id: rowdata.id,
        occupation_name: rowdata.occupation_name,
        mode: EDIT_MODE
    })
  
      setVisible(true);
  
    };
  
  
    const onClose = () => {
      setVisible(false);
    
    };
  
  
    
  
  
    const columns = [
      { 
        title: '#', 
        dataIndex: 'index', 
        render: (text, record, index) => (page - 1) * 10 + ++index ,
        width: '5%',
      },
      {
        title: 'Title',
        dataIndex: 'occupation_name',
        key: 'occupation_name',
        sorter: (a, b) => a.occupation_name.localeCompare(b.occupation_name),
        
      },
      
      {
        title: 'Action',
        key: 'action',
        render: (selectedObj) => (
          <Space size="middle">
            <Button htmlType="button" type="ghost" size="small" shape="round" onClick={()=> showDrawer(selectedObj)}>Edit <EditOutlined /></Button>
          </Space>
        ),
        width: '15%',
      },
    ];
  
  
    useEffect(() => {
        
        occupationService.list().then((res) => {
            setOccupationList(res.data.response_data);
            setFilteredSearchList(res.data.response_data);
            //dispatch(addOccupation(res.data.response_data));
        });
    }, [state.occupation])


    const onSearch = (e) => {
     
      setFilteredSearchList([]);
      const string = e.target.value;

      //previous code
      // const filtered_list = occupationList.filter((data) => JSON.stringify(data).toLowerCase().indexOf(string.toLowerCase()) !== -1);
      
      //Modified - 5/4/24
      const filtered_list = occupationList.filter(data => data.occupation_name.toLowerCase().indexOf(string.trim().toLowerCase()) !== -1);
      setFilteredSearchList(filtered_list)
    }
  
    return (
      <>

        <CustomTableSearch onSearchTable={onSearch} />
        <Table columns={columns} 
          rowKey='id' 
          dataSource={filteredSearchList}  
          //pagination={{ showTotal }} 
          pagination={{
            showTotal,
            onChange(current) {
              setPage(current);
            }
          }}
          size="small"
        />
  
        <Drawer
            title="Edit Occupation"
            width={DEFAULT_MASTER_DRAWER_WIDTH}
            onClose={onClose}
            visible={visible}
            bodyStyle={{
              paddingBottom: 80,
            }}
            destroyOnClose = {true}
            closeIcon = {<><DrawableCloseIcon /></>}
          >
            <OccupationEntry data={occupationData}  onDrawerClose={onClose} />
          </Drawer>
  
      </>
    );
}

export default OccupationList